module.exports = __webpack_public_path__ + "img/Practical Fixer.e4c54ef7.svg";